import { fabric } from "fabric"
import { nodePalette } from "../../theme"
import GameObject from "../modules/GameObject"
import DynamicStrokeCircle from "./DynamicStrokeCircle"
import { LinkedGroup } from "./LinkedGroup"

export type simpleCircleGraphicsOptions = {
	obj: GameObject,
	x: number,
	y: number,
	size: number,
	symbol: string,
	color: string,
	trueSize?: boolean,
	border?: (string | (() => string)),
	evented?: boolean
}

const simpleCircleGraphics = ({
	obj,
	x,
	y,
	size,
	symbol,
	color,
	border = nodePalette.border,
	trueSize = false,
	evented = false
}: simpleCircleGraphicsOptions) => {

	const circle = new DynamicStrokeCircle({
		fill: color,
		originX: 'center',
		originY: 'center',
		radius: size / 2,
		stroke: border,
		strokeWidth: 4,
	})

	const text = new fabric.Text(symbol, {
		fontSize: trueSize ? size : (size / 2),
		originX: 'center',
		originY: 'center',
		fontFamily: 'Segoe UI Emoji',
		evented: false,
	})

	const group = new LinkedGroup([circle, text], {
		top: y,
		left: x,
		originX: 'center',
		originY: 'center',
		hasBorders: true,
		hasControls: false,
		selectable: false,
		evented,

		linkedObject: obj
	})

	group.addComponent('circle', circle)
	group.addComponent('text', text)

	return group
}

export default simpleCircleGraphics